@if (
  {
    fullName: fullName(),
    username: username()
  };
  as STATE
) {
  <section class="user-infos" [matTooltip]="STATE.username || '-'">
    <div class="user-infos__avatar">
      <img src="assets/icons/admin.svg" alt="" class="user-infos__avatar-img" />
    </div>
    <div class="user-infos__content">
      <span class="user-infos__name">
        {{ STATE.fullName }}
      </span>
      <br />
      <span class="user-infos__username">
        {{ STATE.username }}
      </span>
    </div>
  </section>
}
